<template>
    <main class="pd-main">
        <div class="main-content">
            <circle-spin class="m-0" v-if="loading"></circle-spin>
            <div class="card" v-else>
                <h4 class="card-title text-uppercase header-bar">
                    <div class="flexbox justify-content-start">
                        <a href="#" @click="goToList" :class="list?'chat-sm-hidden':'chat-sm-visible'" class="mr-10 chat-md-hidden">
                            <i class="ion-arrow-left-c"></i>
                        </a>
                        <strong>Edit {{title}}</strong>
                    </div>
                    <button v-if="save_training" disabled class="btn btn-bold btn-xs btn-primary"> 
                        <circle-spin></circle-spin>
                    </button>
                    <button :class="list?'chat-sm-visible':'chat-sm-hidden'"  v-else class="btn btn-bold btn-xs btn-primary" @click="saveTraining">Save</button>
                </h4>
                   
                <div class="row no-margin nav-tabs-left">
                        <ul class="chat-sm-hidden tabs-striped pr-0 nav nav-tabs col-md-4 br-1 border-secondary">
                            <div class="scroll h-default">
                            <li class="nav-item" v-for="(topic,i) in sub_topics" :key="i">
                                <a class="nav-link" data-toggle="tab" :href="`#topic${i}`" @click="showContent(i)">{{topic}}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" :href="`#topic${sub_topics.length}`" @click="addNew">Add New Section</a>
                            </li>
                            </div>
                        </ul>
                    
                        <ul :class="list?'chat-sm-visible':'chat-sm-hidden'" class="chat-md-hidden tabs-striped pr-0 nav nav-tabs col-md-4 br-1 border-secondary">
                            <div class="scroll h-default">
                            <li class="nav-item" v-for="(topic,i) in sub_topics" :key="i">
                                <a class="nav-link" data-toggle="tab" :href="`#topic${i}`" @click="showContentMobile(i)">{{topic}}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" :href="`#topic${sub_topics.length}`" @click="addNewMobile">Add New Section</a>
                            </li>
                            </div>
                        </ul>
                     
                    <div class="p-20 tab-content col-md-8">
                        <div v-if="!show_content" class="p-60">
                            <div class="text-center">
                                <div class="pb-10">
                                    <i class="fs-svg ion-ios-list"></i>
                                </div>
                                <p>Click on a topic to edit.</p>
                            </div>
                        </div>
                        <form :id="`topic${index}`" :class="list?'chat-sm-hidden tab-pane fade':'chat-sm-visible'" :style="deleted?'display:none':null" >
                            <div class="form-group">
                                <label for="sub_topic">Topic</label>
                                <input class="form-control" type="text" id="sub_topic" v-model="sub_topic"/>
                                <div v-if="error">
                                    <div class="custom-error">*A topic is required.</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="sub_content">Description</label>
                                <textarea class="form-control" rows="10" style="resize: none" id="sub_content" v-model="sub_content">
                                </textarea>
                                <div v-if="error">
                                    <div class="custom-error">*Content is required.</div>
                                </div>
                            </div>
                            <button v-if="new_section" class="mb-10 btn btn-sm btn-bold btn-primary" @click="addContent" type="button">Add</button>
                            <div v-else>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" @click="updateContent" type="button">Update</button>
                                <button class="mb-10 ml-10 btn btn-sm btn-bold btn-danger" @click="deleteContent" type="button">Delete</button>
                            </div>
                            <div v-if="success">
                                <div>*Saved.</div>
                            </div>
                            <div v-if="delete_topic">
                                <div>*Deleted.</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: true,
            id: null,
            show_content: false,
            list: true,
            title: "",
            index: null,
            sub_topic: "",
            sub_content: "",
            sub_topics: [],
            sub_contents: [],
            error: false,
            save_training: false,
            success: false,
            delete_topic: false,
            deleted: false,
            new_section: false
        }
    },
    methods: {
        goToList() {
            this.list = true
            this.success = false
            this.delete_topic = false
        },
        showContent(i) {
            this.index = i
            this.show_content = true
            this.deleted = false
            this.new_section = false
            this.sub_topic = this.sub_topics[i]
            this.sub_content = this.sub_contents[i]
        },
        showContentMobile(i) {
            this.list = false
            this.showContent(i)
        },
        addNew() {
            this.show_content = true
            this.sub_topic = ''
            this.sub_content = ''
            this.new_section = true
            this.index = this.sub_topics.length
        },
        addNewMobile() {
            this.list = false
            this.addNew()
        },
        addContent() {
            if (this.sub_topic == '' || this.sub_content == '') {
                this.error = true
            }
            else {
                this.sub_topics.push(this.sub_topic)
                this.sub_contents.push(this.sub_content)
                this.success = true
                setTimeout(() => {
                    this.goToList()
                    this.sub_topic = ''
                    this.sub_content = ''
                }, 2000)
            }
        },
        updateContent() {
            if (this.sub_topic == '' || this.sub_content == '') {
                this.error = true
            }
            else {
                this.sub_topics[this.index] = this.sub_topic
                this.sub_contents[this.index] = this.sub_content
                this.success = true
                setTimeout(() => {
                    this.goToList()

                }, 2000)
            }
        },
        deleteContent() {
            this.sub_topics.splice(this.index, 1)
            this.sub_contents.splice(this.index, 1)
            this.delete_topic = true
            setTimeout(() => {
                this.show_content = false
                this.deleted = true
                this.goToList()
            }, 2000)
        },
        saveTraining() {
            this.save_training = true
            let userData = {
                // id: this.id,
                title: this.title,
                sub_topics: this.sub_topics,
                sub_content: this.sub_contents.join(' ||| ')
            }
            axios.patch(`/admin/update?type=training&id=1`, userData)
            .then(res => {
                this.save_training = false
                this.$notify({
                            group: 'response',
                            type: 'success',
                            title:'Successfully updated training',
                            duration: 2500,
                            ignoreDuplicates: true
                        });
                        setTimeout(() => {
                            this.$router.push(`/admin/trainings/${this.id}`)
                        }, 3000)
                        
            })
            .catch(err => {
                this.loading = false
                this.$notify({
                            group: 'response',
                            type: 'error',
                            title: `${err.response.data.message}`,
                            duration: 2500,
                            ignoreDuplicates: true
                        });
            })
        }
    },
    mounted() {
        this.loading = true
        this.id = this.$route.params.id
        axios.get(`/admin/get?type=training&id=${this.id}`)
        .then(res => {
            this.loading = false
            this.title = res.data.content.title
            this.sub_topics = res.data.content.sub_topics
            this.sub_contents = res.data.content.sub_content
        })
        .catch(err => {
            this.loading = false
            this.$notify({
                        group: 'response',
                        type: 'error',
                        title: `${err.response.data.message}`,
                        duration: 5000,
                        ignoreDuplicates: true
                    });
        })
    }
}
</script>